<script>
import { prepaidFormatUsageRules, prepaidFormatUsedTimes } from "@utils/ipetbooking-prepaid";
import formatPrice, { formatPriceRange } from "@utils/format-price";
import formatCurrency from "@utils/format-currency";
import _uniqBy from "lodash/uniqBy";
import { authComputed, merchantComputed } from "@store/helpers";
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";
import { Fancybox } from "@fancyapps/ui";
import getISODay from "date-fns/getISODay";
import formatDay from "@utils/format-day";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          alias: ''
        }
      }
    },
    prepaidItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    priceItem: {
      type: Object,
      default: () => {
        return {
          "title": "經典洗澡卡『深層潔淨』迷你型",
          "alias": "uc18fu7bggrtkg0yt9nh",
          "sizeTitle": "迷你犬（3kg以下）",
          "price": 2600
        }
      }
    },
    prepaidItemSizeOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      toDayDay: getISODay(new Date()),
      showError: false,   
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    prepaidType() {
      if(this.prepaidItem.alias.indexOf('dog') > 1) {
        return 'dog'
      }

      else if(this.prepaidItem.alias.indexOf('cat') > 1) {
        return 'cat'
      }

      else {
        return ''
      }
    },
    applicableEventList() {
      const applicableEvents = this.submitData.size
        ? this.priceItem.applicableEvents
        : this.prepaidItem.priceTable[0].applicableEvents;

      return _uniqBy(applicableEvents, 'groupId')
    },
    usageRuleList() {
      return prepaidFormatUsageRules(this.prepaidItem.usageRules)
    },
    usageRuleText() {
      let usageRuleText = '';

      this.usageRuleList.forEach(item => {
        const timeText = () => {
          let timeText = '';

          item.times.forEach(timeItem => {
            if(timeItem.startTime !== '00:00' || timeItem.endTime !== '23:59') {
              timeText += `\n  。${timeItem.startTime} ~ ${timeItem.endTime}`
            }
          });

          return timeText
        };

        if(item.rangeType === 'date') {
          const dateText = `${item.startDate} ~ ${item.endDate}`;

          usageRuleText += `\n▸ ${dateText}${timeText()}`;
        }

        // 00:00 ~ 08:00
        // 07:00 ~ 09:00

        if(item.rangeType === 'week') {
          const weekTextMap = {
            '1': '週一',
            '2': '週二',
            '3': '週三',
            '4': '週四',
            '5': '週五',
            '6': '週六',
            '0': '週日'
          };
          const weekText = item.range.map(week => {
            return weekTextMap[week]
          }).join('、');

          usageRuleText += `\n▸ ${weekText}${timeText()}`;
        }
      });

      return usageRuleText
    },
  },
  mounted() {
    this.$bus.$on("infoBoxJtails:validateObserver", this.validateObserver);
  },
  destroy: function() {
    this.$bus.$off("infoBoxJtails:validateObserver");
  },
  methods: {
    prepaidFormatUsedTimes,
    formatPrice,
    formatPriceRange,
    formatCurrency,
    formatDay,
    async validateObserver() {
      const delay = (s) => {
        return new Promise(resolve => {
          setTimeout(resolve,s);
        });
      };

      this.showError = true;
      this.$refs['observer'].reset();

      await delay(300);
      await this.$refs['observer'].validate();
    },
    formatPhonenumber(phonenumber = '') {
      const [number] = phonenumber.split('-');

      return number
        ? phonenumber
        : ''
    },
    openFancybox() {
      const imageList = this.storeItem.images.map(item => {
        return {
          src: item.path,
          thumb: item.path,
          caption: "",
        }
      });

      Fancybox.show(imageList, {
        mainClass: 'isStyleJtails',
        Toolbar: {
          display: [
            { id: "prev", position: "center" },
            { id: "counter", position: "center" },
            { id: "next", position: "center" },
            "close",
          ],
        },
      });

      Fancybox.getInstance().jumpTo(this.pageCount - 1);
    },
    onClickApplicableEvents(item, column) {
      const { label } = column
      if (label === '服務項目') {
        this.openDialogApplicableItem(item)
      }
    },
    openDialogApplicableItem(item) {
      this.$globalDialog('DialogReservation', {
        ...item
      })
    },
  },
}
</script>
<!-- section template -->
<template>
  <section :class="[$style.itemSectionContentJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]" class="section">
    <div class="itemSectionContentJtails__imageBox">
      <div
        class="itemSectionContentJtails__image"
        :style="{ backgroundImage: `url('${ prepaidItem.image || $globalIsDingBeauty ? require('@assets/images/dingbeauty/default/service-default-Image.svg') : require('@assets/images/default/plan-default-Image@2x.png') }')` }"
      ></div>
      <div class="itemSectionContentJtails__metaBox">
        <div class="itemSectionContentJtails__metaText">
          總抵用次數
        </div>
        <div class="itemSectionContentJtails__metaTimes">
          {{ prepaidItem.times }}
        </div>
      </div>
    </div>
    <BaseStoreTagList
      v-if="$globalIsDingBeauty"
      :store-list="prepaidItem.stores"
      class="mb-4"
    />
    <div class="itemSectionContentJtails__titleBox">
      <div v-if="$globalIsJtails" class="itemSectionContentJtails__icon">
        <i :class="`fontello fontello-${ prepaidType }`"></i>
      </div>
      <div>
        <h2
          :to="{ name: 'prepaid-item', params: { prepaidAlias: prepaidItem.alias, size: submitData.size } }"
          class="itemSectionContentJtails__title"
        >
          {{ prepaidItem.title }}
        </h2>
        <div v-if="prepaidItem.slogan" class="itemSectionContentJtails__subTitle pt-3">
          {{ prepaidItem.slogan }}
        </div>
      </div>
    </div>
    <BaseStoreTagList
      v-if="!$globalIsDingBeauty"
      :store-list="prepaidItem.stores"
      class="mb-5"
    />
    <template v-if="currentMerchant.prepaidSetting.isEnabled && currentMerchant.petCategories[0] && currentMerchant.petCategories[0].children.length > 1">
      <ValidationObserver ref="observer" v-slot="{ invalid, handleSubmit }">
        <el-form
          id="size"
          ref="form"
          :model="submitData"
          label-position="top"
          class="isStylePrepaidJtails"
        >
          <ValidationProvider
            v-slot="{ errors }"
            :rules="'require'"
            name="體型"
          >
            <el-form-item :error="showError && errors[0] ? ' ' : ''" prop="alias">
              <el-select
                ref="alias"
                v-model="submitData.alias"
                placeholder="請選擇體型"
              >
                <el-option
                  v-for="(option, $index) in prepaidItemSizeOptions"
                  :key="`prepaidItemSizeOptions-${$index}`"
                  :label="option.text"
                  :value="option.value">
                  <div>
                    {{ option.text }} <span class="text-gray-2">{{ formatPrice(option.price) }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </ValidationProvider>
        </el-form>
      </ValidationObserver>
    </template>
    <div  v-if="currentMerchant.prepaidSetting.isEnabled" class="itemSectionContentJtails__price">
      <template v-if="!!submitData.alias">
        {{  priceItem.levelDiscount > 0 
          ? `會員價$NT ${formatCurrency(memberLevelPriceDiscount(priceItem.price, priceItem))}`
          : formatPrice(priceItem.price) 
        }}
        <br v-if="priceItem.levelDiscount > 0 " class="d-md-none">
        <span
          v-if="priceItem.levelDiscount > 0 "
          class="itemSectionContentJtails__basePrice"
        >
          售價NT$ {{ formatCurrency(priceItem.price) }}
        </span>
        <span
          v-if="priceItem.price < priceItem.basePrice && !priceItem.levelDiscount > 0"
          class="itemSectionContentJtails__basePrice"
        >
          原價NT$ {{ formatCurrency(priceItem.basePrice) }}
        </span>
      </template>
      <template v-else>
        {{ formatPriceRange(prepaidItem.minPrice, prepaidItem.maxPrice) }}
      </template>
    </div>
    <hr>
    <div
      v-if="!!usageRuleList[0]"
      class="mb-5"
    >
      <BaseSectionTitleJtails
        title="使用限制"
        title-class="text-primary-dark"
        :description="`此方案無法在以下時段使用${usageRuleText}`"
        sub-title="UsageRule"
      />
    </div>
    <div
      v-if="!!prepaidItem.priceTable[0].applicableEvents[0]"
      class="mb-5"
    >
      <div id="applicableEvents" style="position: relative; top: -6rem"></div>
      <BaseSectionTitleSecondary
        v-if="$globalIsDingBeauty"
        title="服務項目"
        title-class=""
      />
      <BaseSectionTitleJtails
        v-else
        title="服務項目"
        title-class="text-primary-dark"
        sub-title="Service"
      />
      <div class="tableVertical d-md-none">
        <div
          v-for="(applicableEventItem, index) in applicableEventList"
          :key="index"
          class="tableVertical__item"
        >
          <div class="tableVertical__top">
            {{ applicableEventItem.title }}
          </div>
          <ul class="tableVertical__content">
            <li>
              <span class="tableVertical__content__title">抵用上限</span>
              <span class="tableVertical__content__content" :title="applicableEventItem.times">
                {{ prepaidFormatUsedTimes(applicableEventItem.times) }}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <el-table
        :data="applicableEventList"
        class="isStyleBase isHoverNoBg d-none d-md-block"
        :class="[$style.applicableEventsTable, { 'isStyleDingBeauty': $globalIsDingBeauty }]"
        @row-click="onClickApplicableEvents"
      >
        <el-table-column v-slot="{ row }" label="服務項目" :mim-width="40">
          <span class="applicableEventsTable__title isTableUnderline">{{ row.title }}</span>
        </el-table-column>

        <el-table-column v-slot="{ row }" label="抵用上限" width="80" align="right">
          <span :title="row.times">{{ prepaidFormatUsedTimes(row.times) }}</span>
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="prepaidItem.description"
      class="mb-5"
    >
      <div id="description" style="position: relative; top: -6rem"></div>
      <BaseSectionTitleSecondary
        v-if="$globalIsDingBeauty"
        title="方案說明"
        title-class=""
        :description="prepaidItem.description"
      />
      <BaseSectionTitleJtails
        v-else
        title="方案說明"
        title-class="text-primary-dark"
        sub-title="Instruction"
        :description="prepaidItem.description"
      />
    </div>
    <div
      v-if="prepaidItem.notice"
      class="mb-5"
    >
      <div id="notice" style="position: relative; top: -6rem"></div>
      <BaseSectionTitleSecondary
        v-if="$globalIsDingBeauty"
        title="注意事項"
        title-class=""
        :description="prepaidItem.notice"
      />
      <BaseSectionTitleJtails
        v-else
        title="注意事項"
        title-class="text-primary-dark"
        sub-title="Notice"
        :description="prepaidItem.notice"
      />
    </div>
    <template v-if="!!prepaidItem.stores[0]">
      <div id="applicableStore" style="position: relative; top: -6rem"></div>
      <template v-if="prepaidItem.stores[0].storeType === 'home'">
        <BaseSectionTitleJtails
          class="mb-3"
          title="服務範圍"
          title-class="text-primary-dark"
          sub-title="Location"
        />
      </template>
      <template v-if="prepaidItem.stores[0].storeType === 'store'">
        <BaseSectionTitleSecondary
          v-if="$globalIsDingBeauty"
          title="服務地點"
          title-class=""
        />
        <BaseSectionTitleJtails
          v-else
          class="mb-3"
          title="服務地點"
          title-class="text-primary-dark"
          sub-title="Location"
        />
      </template>
      <div :class="$style.locationList">
        <div
          v-for="(storeItem, index) in prepaidItem.stores"
          :key="`storeItem-${index}`"
          class="locationList__item"
        >
          <template v-if="storeItem.storeType === 'home' && !!storeItem.params.addressRestrictions[0]">
            <div class="locationList__title">{{ storeItem.title }}</div>
            <ul :class="$style.areaList">
              <li
                v-for="(areaItem, key, index) in storeItem.params.addressRestrictions"
                :key="index"
                class="areaList__item"
              >
                <span class="areaList__title">{{ areaItem.city }}</span>
                <span class="areaList__text">
                  {{ areaItem.district.join(', ') }}
                </span>
              </li>
            </ul>
          </template>
          <template v-if="storeItem.storeType === 'store' && ( storeItem.fullAddress || (storeItem.lat && storeItem.lng) )">
            <div class="row">
              <div
                v-if="storeItem.lat && storeItem.lng"
                class="itemSectionContentJtails__googleMapBox"
                :class="$globalIsDingBeauty ? 'col-md-6' : 'col-12'"
              >
                <GmapMap
                  :center="{ lat: storeItem.lat, lng: storeItem.lng }"
                  :zoom="18"
                  map-type-id="terrain"
                  class="itemSectionContentJtails__googleMap"
                >
                  <GmapMarker
                    :position="{ lat: storeItem.lat, lng: storeItem.lng }"
                    :icon="`${require('@assets/images/reservation/locate.png')}`"
                  />
                </GmapMap>
              </div>
              <div v-if="$globalIsDingBeauty" class="col-md-6">
                <div class="fs-lg mb-2 mt-md-0 mt-3">{{ storeItem.title }}</div>
                <ul :class="[$style.metaList]" >
                  <li
                    v-if="!!formatPhonenumber(storeItem.phoneNumber)"
                    class="metaList__item"
                  >
                    <a
                      :href="`tel:${ formatPhonenumber(storeItem.phoneNumber) }`"
                      class="metaList__link"
                    >
                      <i class="metaList__icon fontello fontello-phone fa-fw"></i>
                      <span class="metaList__text">{{ formatPhonenumber(storeItem.phoneNumber) }}</span>
                    </a>
                  </li>
                  <template v-if="!storeItem.storeType || storeItem.storeType === 'store'">
                    <li
                      v-if="!!storeItem.fullAddress"
                      class="col-12 metaList__item"
                    >
                      <a
                        :href="`https://www.google.com.tw/maps/search/${ storeItem.fullAddress }`"
                        class="metaList__link"
                        target="_blank"
                      >
                        <i class="metaList__icon fontello fontello-locate fa-fw"></i>
                        <span class="metaList__text">{{ storeItem.fullAddress }}</span>
                      </a>
                    </li>
                    <li
                        v-if="!!storeItem.params.serviceTimeSetting[toDayDay].start && !!storeItem.params.serviceTimeSetting[toDayDay].end"
                        class="metaList__item"
                      >
                      <el-popover
                        placement="bottom-start"
                        :trigger="$globalBreakpoint === 'xs' || $globalBreakpoint === 'sm' || $globalBreakpoint === '2sm' || $globalBreakpoint === 'md' ? 'click' : 'hover'"
                        content=""
                      >
                        <div
                          slot="reference"
                          class="metaList__link"
                        >
                          <i class="metaList__icon fontello fontello-info fa-fw"></i>
                          <span class="metaList__text">
                            <span>今日</span>
                            <span
                              v-if="!!storeItem.params.serviceTimeSetting[toDayDay].isOpen"
                              class="font-number"
                            >營業時間
                              {{
                                storeItem.params.serviceTimeSetting[toDayDay].start
                              }}-{{ storeItem.params.serviceTimeSetting[toDayDay].end }}</span>
                          <span v-else>不營業</span>
                          </span>
                          <i class="fontello fontello-down fa-sm metaList__textIcon ml-1"></i>
                        </div>
                        <div>
                          <ul :class="$style.dayList">
                            <li
                              v-for="(dayItem, key, index2) in storeItem.params.serviceTimeSetting"
                              :key="index2"
                              class="dayList__item"
                              :class="{ isActive: toDayDay.toString() === key }"
                            >
                              <span class="dayList__title">{{ formatDay(key) }}</span>
                              <span
                                v-if="!!dayItem.isOpen"
                                class="dayList__time"
                              >{{
                                  storeItem.params.serviceTimeSetting[key].start
                                }}-{{ storeItem.params.serviceTimeSetting[key].end }}</span>
                              <span v-else>不營業</span>
                            </li>
                          </ul>
                        </div>
                      </el-popover>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </template>
        </div>
      </div>
<!--      <div
        v-for="(storeItem, index) in prepaidItem.stores"
        :key="`storeItem-${index}`"
        class="mb-5"
      >
        <BaseSectionTitleSecondary
          title="適用分店"
        >
          <a
            slot="description"
            :href="`https://www.google.com.tw/maps/search/${ storeItem.fullAddress }`"
            target='_blank'
          >
            <span>{{ storeItem.title }}: {{ storeItem.fullAddress }}</span>
            <i class="far fa-external-link-alt fa-sm ml-1"></i>
          </a>
        </BaseSectionTitleSecondary>
        <div
          v-if="storeItem.lat && storeItem.lng"
          class="itemSectionContentJtails__googleMapBox"
        >
          <GmapMap
            :center="{ lat: storeItem.lat, lng: storeItem.lng }"
            :zoom="18"
            map-type-id="terrain"
            class="itemSectionContentJtails__googleMap"
          >
            <GmapMarker
              :position="{ lat: storeItem.lat, lng: storeItem.lng }"
              :icon="`${require('@assets/images/reservation/locate.png')}`"
            />
          </GmapMap>
        </div>
      </div>-->
    </template>
    <BasePre>{{ submitData }}</BasePre>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
.itemSectionContentJtails {
  :global {
    .itemSectionContentJtails {
      &__googleMap {
        height: 250px;
      }

      &__googleMapBox {
        overflow: hidden;
      }

      &__titleBox {
        display: flex;
        align-items: center;
        margin-bottom: 0.25rem;
      }

      &__icon {
        margin-top: -0.25em;
        margin-right: 0.5rem;
        font-size: 3rem;
        color: $color-primary;
      }

      &__title {
        display: block;
        font-family: $font-serif;
        font-size: 1.25rem;
        font-weight: 600;
        color: $color-primary-dark;
        letter-spacing: 0.2em;
        transition: color 0.3s;
      }

      &__subTitle {
        font-size: 0.875rem;
        color: #726F65;
      }

      &__imageBox {
        position: relative;
        display: block;
        padding-top: 48.5%;
        margin: -1px -1px 1.25rem -1px;
        overflow: hidden;
      }

      &__image {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);
      }

      &__metaBox {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 0.5rem 2rem;
        color: #fff;
        text-align: right;
        background: rgba($color-primary, 0.9);
      }

      &__metaText {
        font-size: 0.875rem;
      }

      &__metaTimes {
        font-family: $font-number;
        font-weight: 700;
      }

      &__price {
        font-family: $font-number;
        font-size: 1.5rem;
        font-weight: 500;
        color: $color-primary;
      }
      &__basePrice {
        font-family: $font-number;
        font-size: 0.875rem;
        color: $color-gray-2;
        text-decoration: line-through;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .itemSectionContentJtails { 
        &__title {
          color: $color-secondary;
        }
        &__subTitle {
          margin-bottom: 1.75rem;
        }
      }
    }
  }
}

.applicableEventsTable {
  :global {
    .applicableEventsTable {
      @include unstyled;
    }
  }
}

.areaList {
  @include list-unstyled;

  :global {
    .areaList {
      &__item {
        line-height: 1.75;

        &:not(:last-child) {
          margin-bottom: 0.5rem;
        }
      }

      &__title {
        display: block;
        font-family: $font-serif;
        font-size: 0.875rem;
        font-weight: 600;
        color: $color-primary-dark;
      }

      &__text {
        font-size: 0.875rem;
      }
    }
  }
}

.locationList {
  margin: -1rem 0;
  :global {
    .locationList {
      &__item {
        padding: 1rem 0;
        &:not(:last-child) {
          border-bottom: 1px solid $color-line;
        }
      }

      &__title {
        margin-bottom: 0.5rem;
        line-height: 1.75;
        color: #3F3A2E;
        white-space: pre-wrap;
      }

      &__link {
        display: block;
        margin-bottom: 0.5rem;
        font-size: 0.875rem;
        line-height: 1.75;
        color: #3F3A2E;
        white-space: pre-wrap;

        &:hover {
          color: $color-primary;
        }
      }

    }
  }
}
.metaList {
  @include list-unstyled;

  min-height: 5.5rem;
  margin-bottom: 2.5rem;
  line-height: 1.5;

  @include max-md {
    min-height: auto;
  }

  :global {
    .metaList {
      &__item {
        margin-bottom: 1rem;
        padding-bottom: 1rem;
        letter-spacing: 0.1em;
        border-bottom: 1px solid $color-line-2;
      }

      &__icon {
        padding-top: 0.15rem;
        margin-right: 0.5rem;
        color: $color-gray-3;
      }

      &__link {
        @include link-unstyled;

        display: inline-flex;
        font-size: 0.875rem;
        color: $color-gray-3;

        &[href] {
          &:hover, &:focus {
            color: $color-primary;

            .metaList {
              &__icon {
                color: $color-primary;
              }
            }
          }
        }
      }

      &__textIcon {
        color: $color-gray-3;
        transform: scale(0.8) translateY(5px);
      }

      &__text {
        @include unstyled;
      }
    }
  }
}
.dayList {
  padding: 0.25rem 0;
  line-height: 2;

  @include list-unstyled;

  :global {
    .dayList {
      &__title {
        margin-right: 0.5rem;
        font-weight: 500;
      }

      &__time {
        font-family: $font-number;
        color: $color-gray-2;
      }

      &__item {
        padding: 0 0.5rem;

        &.isActive {
          color: $color-primary;

          .dayList {
            &__time {
              color: $color-primary;
            }
          }
        }
      }
    }
  }
}
</style>
